export default [
  {
    value: 'Women',
    label: 'Women',
  },
  {
    value: 'Men',
    label: 'Men',
  },
  {
    value: 'Kids',
    label: 'Kids',
  },
  {
    value: 'Beauty',
    label: 'Beauty',
  },
];
